import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@/services/auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

interface TwoFactorDialogData {
  username: string;
}

@Component({
  selector: 'app-two-factor-dialog',
  templateUrl: './two-factor-dialog.component.html',
})
export class TwoFactorDialogComponent {
  /** Control del código de 6 dígitos */
  codigoControl = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TwoFactorDialogData,
    private dialogRef: MatDialogRef<TwoFactorDialogComponent>,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) { }

  /**
   * Valida el código 2FA contra el backend.
   */
  validar(): void {
    if (this.codigoControl.invalid) return;

    this.authService.validate2FA(this.data.username, +this.codigoControl.value!).subscribe({
      next: (res) => {
        
        this.authService.iniciarSesion(res);
        this.dialogRef.close(true); // notificamos éxito
      },
      error: () => {
        this.codigoControl.setErrors({ invalid: true });
      },
    });
  }
}